import React, { PureComponent } from 'react';
import { Helmet } from 'react-helmet';
import PropTypes from 'prop-types';
import SubnavigationContent from './SubnavigationContent';

import './subnavigation.scss';

class SubnavigationTemplate extends PureComponent {
  render() {
    const { navigationTabs, activeIndex, isMobile } = this.props;
    const activeTab = navigationTabs[activeIndex];

    return (
      <div className="subnavigation-page">
        <Helmet>
          <title>{activeTab.meta.title} - Навигация</title>
        </Helmet>

        <SubnavigationContent
          activeTab={activeTab}
          isMobile={isMobile}
          showTabContent={true}
        />
      </div>
    );
  }
}

SubnavigationTemplate.propTypes = {
  activeIndex: PropTypes.number,
  navigationTabs: PropTypes.arrayOf(PropTypes.object),
  isMobile: PropTypes.bool
};

export default SubnavigationTemplate;



// WEBPACK FOOTER //
// ./src/components/Subnavigation/SubnavigationTemplate.js